export enum MILESTONE_TYPE {
    WORKING = "working",
    BANKING = "banking",
    CALENDAR = "calendar",
}
